__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "icon.core.ui.client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "1.8.0", () => (Promise.all([__webpack_require__.e(823), __webpack_require__.e(781)]).then(() => (() => (__webpack_require__(38823))))));
			register("axios", "0.21.4", () => (__webpack_require__.e(569).then(() => (() => (__webpack_require__(21405))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(122)]).then(() => (() => (__webpack_require__(54164))))));
			register("react-redux", "7.2.6", () => (Promise.all([__webpack_require__.e(456), __webpack_require__.e(122), __webpack_require__.e(676), __webpack_require__.e(891)]).then(() => (() => (__webpack_require__(59456))))));
			register("react-router-dom", "6.2.1", () => (Promise.all([__webpack_require__.e(871), __webpack_require__.e(504), __webpack_require__.e(122)]).then(() => (() => (__webpack_require__(43504))))));
			register("react", "17.0.2", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(72791))))));
			initExternal(92491);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};